/* ============================================================
   LOT 30 (10/08/2026) — point 4b : les puces du carrousel d'avis
   ne suivaient pas le defilement.
   Theme LOVI V13 — PERF (Claude) 198891929927, UNPUBLISHED.

   DIAGNOSTIC, mesure sur le DOM rendu :
   1) Le script de la section fait defiler et pose bien is-active
      sur .lovi-revcar__card, mais il ne contient AUCUNE reference
      aux puces : 0 occurrence de la classe .lovi-revcar__dot.
      Les puces sont du balisage Liquid, cablees pour le clic
      (attribut data-rc-dot) mais jamais repeintes. Preuve : apres
      un defilement jusqu'a la carte 3, la carte 3 recoit is-active
      et la puce 1 la garde ; aria-current reste "true" sur la 1.
   2) Piege evite par la mesure : la piste contient 2 fois plus de
      cartes que d'avis. Les secondes portent data-rc-clone et
      aria-hidden="true" — ce sont les doublons de bouclage poses
      par la section. Aligner le nombre de puces sur le nombre de
      CARTES aurait affiche 8 puces pour 4 avis. La puce active se
      calcule modulo le nombre d'avis REELS.
   3) Deuxieme piege, trouve en verifiant l'etat final et pas
      seulement l'etat injecte a la main : les clones sont ajoutes
      par la section APRES notre init. Une liste de cartes captee
      une fois pour toutes ne voyait que les 4 originales, et tout
      defilement au-dela de la 4e retombait sur la derniere puce.
      Les listes sont donc relues a chaque peinture — le cout est
      un querySelectorAll sur 8 noeuds, negligeable.

   CE QUE FAIT CE FICHIER
   - reconcilie le nombre de puces avec le nombre d'avis reels
     (creation par clonage si le gabarit en rend moins, masquage
     par l'attribut hidden s'il en rend plus — jamais de suppression
     de noeud) ;
   - repeint la puce active a chaque defilement, en synchrone : le
     debit d'un carrousel ne justifie pas d'etranglement, et un
     etranglement par requestAnimationFrame se bloque dans un
     onglet en arriere-plan (constate en harnais de mesure) ;
   - fait defiler vers la bonne carte au clic sur une puce, en
     phase de CAPTURE avec stopPropagation, pour que le gestionnaire
     historique de la section ne lance pas un second defilement
     concurrent vers une cible differente ;
   - expose rev.__lot30paint() pour que les lots suivants puissent
     verifier l'etat sans dependre d'une minuterie.

   VERIFICATION (page reelle, 390 px, 4 avis + 4 clones, 4 puces) :
     defilement carte 1..8 -> puce 1 2 3 4 1 2 3 4
     clic puce 1..4        -> defilement 0 / 352 / 704 / 1056
   ============================================================ */
(function(){
  function init(rev){
    var frame=rev.querySelector('.lovi-revcar__frame');
    var box=rev.querySelector('.lovi-revcar__dots');
    if(!frame||!box||rev.__lot30) return;
    rev.__lot30=1;

    /* Listes relues a chaque appel : les clones de bouclage sont
       ajoutes par la section apres notre initialisation.          */
    function cards(){
      return [].slice.call(frame.querySelectorAll('.lovi-revcar__card'));
    }
    function reels(){
      var all=cards();
      var r=all.filter(function(c){
        return !c.hasAttribute('data-rc-clone') && c.getAttribute('aria-hidden')!=='true';
      });
      return r.length?r:all;
    }
    function dotsOf(n){
      var dots=[].slice.call(box.querySelectorAll('.lovi-revcar__dot'));
      var model=dots[0];
      if(model){
        while(dots.length<n){
          var d=model.cloneNode(true);
          d.className=String(model.className).replace(/\s*is-active/g,'');
          box.appendChild(d);
          dots.push(d);
        }
        dots.forEach(function(d,i){
          d.hidden=(i>=n);            /* masque, jamais supprime */
          d.setAttribute('data-rc-dot',String(i));
          d.setAttribute('aria-label','Avis '+(i+1));
        });
      }
      return dots;
    }

    /* Bord gauche d'une carte en coordonnees de contenu. On passe par
       getBoundingClientRect et non par offsetLeft : les fleches de
       navigation sont absolues dans la piste et faussent offsetLeft
       (relevees a -4 px pour la premiere carte).                   */
    function pos(c){
      return (c.getBoundingClientRect().left - frame.getBoundingClientRect().left) + frame.scrollLeft;
    }

    var last=-1;
    function paint(){
      var all=cards(), real=reels();
      if(!all.length||!real.length) return -1;
      var dots=dotsOf(real.length);
      var mid=frame.scrollLeft + frame.clientWidth/2, best=0, bd=Infinity;
      for(var i=0;i<all.length;i++){
        var d=Math.abs(pos(all[i]) + all[i].offsetWidth/2 - mid);
        if(d<bd){ bd=d; best=i; }
      }
      var a=best % real.length;
      if(a===last) return a;
      last=a;
      for(var j=0;j<dots.length;j++){
        var on=(j===a);
        dots[j].classList.toggle('is-active',on);
        dots[j].setAttribute('aria-current',on?'true':'false');
      }
      return a;
    }
    rev.__lot30paint=paint;

    frame.addEventListener('scroll',paint,{passive:true});

    box.addEventListener('click',function(e){
      var d=e.target&&e.target.closest?e.target.closest('.lovi-revcar__dot'):null;
      if(!d) return;
      var i=parseInt(d.getAttribute('data-rc-dot'),10);
      var real=reels();
      if(isNaN(i)||!real[i]) return;
      e.preventDefault();
      e.stopPropagation();
      var pl=parseFloat(getComputedStyle(frame).paddingLeft)||0;
      var max=frame.scrollWidth-frame.clientWidth;
      frame.scrollTo({left:Math.max(0,Math.min(max,pos(real[i])-pl)),behavior:'smooth'});
    },true);

    addEventListener('resize',paint,{passive:true});
    paint();
  }

  function boot(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-lovi-revcar]'),init);
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); }
  else { boot(); }
  addEventListener('load',boot);
})();
